import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import DisclaimerGate from "@/components/DisclaimerGate";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";

// Code-split the heavy, auth-only routes (charts, dialogs) so the public
// landing and /login pages ship a much smaller initial bundle and load fast.
const Admin = lazy(() => import("@/pages/Admin"));
const MyCases = lazy(() => import("@/pages/MyCases"));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-paper">
    <div className="h-6 w-6 border-2 border-signal border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/cases" element={<ProtectedRoute><MyCases /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="/" element={<DisclaimerGate><Landing /></DisclaimerGate>} />
          </Routes>
        </Suspense>
        <Toaster position="top-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
